// extracted by mini-css-extract-plugin
export var grid = "sectionWithGrid-module--grid--c99a8";
export var gridContainer = "sectionWithGrid-module--gridContainer--3fc9c";
export var sectionWithGrid = "sectionWithGrid-module--sectionWithGrid--b58b7";
export var toEdge = "sectionWithGrid-module--toEdge--fc2e9";